import { z } from "zod/v4";

export const DownloadExperienceResponseBodySchema = z.object({
  message: z.string(),
  url: z.string().optional(),
});

export type DownloadExperienceResponseBodyType = z.infer<
  typeof DownloadExperienceResponseBodySchema
>;
